<template id="tabs">
  <div>
    <ul class="nav nav-tabs nav-tabs-fillup offer">
      <li v-for="tab in tabs" v-bind:class="[{'active': current === tab},'item']" v-on:click="changeTab(tab)">
        <a><span>{{tab.title}}</span></a>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
	export default {

	 data: function() {
	    return {
	      tabs: [],
	      current: null
	    };
	  },

	methods: {
	    addTab: function(tab) {
	      this.tabs.push(tab);
	      if (tab.active === true) {
	        this.current = tab;
	      }
	    },

	changeTab: function(tab) {
	      this.current = tab;
	      this.tabs.forEach(function(value) {
	        if (value === tab) {
	          value.active = true;
	        } else {
	          value.active = false;
	        }
	      });
	    },
	}
}

</script>

<style>

/* .offer .nav-tabs > li.active > a, .nav-tabs > li.active > a:hover, .nav-tabs > li.active > a:focus {
    color: #555;
    cursor: default;
    background-color: #fff;
    border: 1px solid #ddd;
    border-bottom-color: transparent;
} */

</style>



// WEBPACK FOOTER //
// client/components/Catalog/CatalogTabs.vue